module.exports = "images/favicon-16x16.258b0f994d5e7c9ad15bcea5ea231666.png";